import { CSSProperties } from 'react';

export const desktopSpaceCardHeight = 96;

export const desktopSpaceCardStyle: CSSProperties = {
  height: `${desktopSpaceCardHeight}px`,
};
